<template>
  <v-col md="8" sm="10" cols="12" pl-4 pr-4>
    <v-card-title class="pb-0 justify-center">
      <v-row class="text-center">
        <v-col cols="12" mb-3>
          <v-icon color="primary" size="50" :icon="mdiCheckCircleOutline" />
        </v-col>
        <v-col cols="12">
          <h2 class="text-h6 font-weight-regular mb-0">
            {{ $t('L_payment_has_been_submitted') }}
          </h2>
        </v-col>
      </v-row>
    </v-card-title>
    <v-card-text class="text-center">
      <v-row justify="center" mt-3>
        <v-col cols="12">
          {{ $t('L_your_kubra_payment_being_processed') }}
        </v-col>
        <v-col cols="12">
          {{ $t('L_payment_may_appear_as') }}
        </v-col>
      </v-row>
    </v-card-text>
  </v-col>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import DynatraceClient from '@/plugins/dynatracePlugin';
import { mapStores } from 'pinia';
import { usePolicyStore } from '@/modules/policy/store/policy.store';
import { mdiCheckCircleOutline } from '@mdi/js';

export default defineComponent({
  name: 'KubraPayment',
  data: () => ({
    mdiCheckCircleOutline,
  }),
  computed: {
    ...mapStores(usePolicyStore),
  },
  methods: {
    closeAndFocus() {
      // const viewPaymentButton = document.querySelector('div.card-slide-item:not(.policy-active) #view_payment_details_container');
      this.policyStore.setPanelValue(-1);
    },
  },
  mounted() {
    /*
     * Emit a custom action when a user successfully submits a Pay Now payment
     * https://www7.v1host.com/Primerica/attachment.img/284635/Analytics%20User%20Stories%20DT_3.30.21.docx
     */
    const i = DynatraceClient.enterAction('pay_now_succesful_submission');
    DynatraceClient.leaveAction(i);
  },
});
</script>
